export const PAGE_TITLE_CONSTANT = {
    GUEST : "Guests",
    SCHEDULE : "Schedule",
    COMMITTEE : "Committee",
    RECAP : "Recap",
    SPEAKER : "Speakers",
    ABOUT : "About"
}


export const HOME_PAGE_CONSTANTS = {
  HOME: 'Home',
};
